import { useTranslation } from 'utils/use-translation'
import styles from './styles.module.scss'

export default function ReferralProgramRules() {
  const { t } = useTranslation()

  return (
    <ol className={styles.rules}>
      <li>
        <span>1</span> {t('referrar_can_invite')}
      </li>
      <li>
        <span>2</span> {t('disquilify_cancel_referral')}
      </li>
      <li>
        <span>3</span> {t('reserves_right_interpret')}
      </li>
    </ol>
  )
}
